jQuery(function() {
    if(jQuery('.swiper-card').length){
        var swiper = new Swiper(".swiper-card", {
             slidesPerView: "auto",
            centeredSlides: false,
            spaceBetween: 30, 
            pagination: false,
            navigation: false,
            scrollbar: false,
            autoplay: {
                delay: 10000,
            },
            breakpoints: {
                320: {
                    spaceBetween: 30,
                },
                768: {
                    spaceBetween: 30,
                }

            }
        });
    }
 });